import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import Blocks from "../blocks";

import studyLogin from "../../assets/images/study-login.svg";
import { IoMdArrowBack } from "react-icons/io";

const PageStartLiveClass = () => {
  const history = useHistory();
  const location = useLocation();
  const user = location.pathname.split("/")[1];
  const goToHome = () => {
    history.push("/");
  };
  return (
    <>
      <div className="page pageStartLiveClass">
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row items-center">
            <h3
              className={
                "flex items-center gap-2 md:hidden text-xl text-center pt-16 pb-4 font-['Poppins-Bold']"
              }
            >
              {user === "teacher" && (
                <IoMdArrowBack
                  size={20}
                  className="cursor-pointer"
                  onClick={() => goToHome()}
                />
              )}
              Start a live class
            </h3>
            <div className="left-section bgWrapper">
              <img src={studyLogin} alt="" />
            </div>
            <div className="right-section flex items-center justify-center w-full max-w-4xl ml-auto ">
              <div className={"block BlockLiveClasses w-full sm:max-w-4xl"}>
                <div className="w-full p-4">
                  <div className="hidden md:flex items-center gap-2 w-full text-4xl font-['Poppins-Bold'] mx-auto mb-2">
                    {user === "teacher" && (
                      <IoMdArrowBack
                        size={40}
                        className="cursor-pointer"
                        onClick={() => goToHome()}
                      />
                    )}
                    Start a live class
                  </div>
                  <Blocks.ErrorBoundary>
                    <div className="classList w-full max-h-screen overflow-scroll px-1 py-2 mt-12">
                      {user === "teacher" ? (
                        <Blocks.BlockTeacherLiveClass />
                      ) : (
                        <Blocks.BlockStudentLiveClass />
                      )}
                    </div>
                    {user === "teacher" ? (
                      <div className="max-w-full mt-4">
                        <button
                          className="shadow rounded-lg h-16 w-full flex items-center"
                          onClick={() => history.push(`/create-virtual-class`)}
                        >
                          <span className="px-8">
                            <i className="text-3xl icon icon-plus-circle"></i>
                          </span>
                          <span className="text-sm">Create a new class</span>
                        </button>
                      </div>
                    ) : (
                      <div className="text-right">
                        {/*   Go to dashboard button has been disabled/commented out for the time being.
                         It can be enabled or modified later based on student dashboard requirements.
                        <button onClick={() => history.push(`/teacher/home`)}>
                          Go to dashboard
                        </button> */}  
                      </div>
                    )}
                  </Blocks.ErrorBoundary>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PageStartLiveClass;
